import "./src/styles/global.css"

// Self-hosted so no request ever goes to fonts.googleapis.com.
import "@fontsource/barlow/300.css"
import "@fontsource/barlow/400.css"
import "@fontsource/barlow/500.css"
import "@fontsource/barlow/600.css"
import "@fontsource/barlow/700.css"
import "@fontsource/barlow-condensed/300.css"
import "@fontsource/barlow-condensed/400.css"
import "@fontsource/barlow-condensed/500.css"
import "@fontsource/barlow-condensed/600.css"
import "@fontsource/barlow-condensed/700.css"

import React from 'react'
import {AnimatedProvider} from "./src/components/provider/AnimatedProvider";
import CookieConsent from "./src/components/ui-kit/CookieConsent";
import {initConsentMode} from "./src/utils/consent";

// Runs before any page renders: sets Consent Mode v2 to denied and replays a
// stored decision. GTM is only injected from here, never at build time.
export const onClientEntry = () => {
    initConsentMode()
};

export const wrapRootElement = ({element}) => {


    return <AnimatedProvider>
        {element}
        <CookieConsent/>
    </AnimatedProvider>
};